import {
  Component, Input, OnInit,
} from '@angular/core';

@Component({
  selector: 'app-course-request-general-info',
  templateUrl: './course-request-general-info.component.html',
  styleUrls: [ './course-request-general-info.component.scss' ],
})
export class CourseRequestGeneralInfoComponent {
  @Input() course: any;
  @Input() courseTypes: any;


  constructor() { }

  updateCourse = (event: any, parameter: string) => {
    if (parameter === 'description') {
      this.course.description = event;
    } else if (parameter === 'courseType') {
      const selectedCourseType = this.courseTypes.find((courseType: any) => courseType.courseType === event.target.value);

      if (selectedCourseType) {
        this.course.courseType = selectedCourseType.courseType;
        this.course.courseTypeObject = selectedCourseType;
      }
    } else {
      this.course[parameter] = event.target.value;
    }
  }

  asyncToggle = () => {
    this.course.async ? this.course.anytime = false : null;
    this.course.async ? this.course.courseStartTime = '' : null;
    this.course.async ? this.course.courseEndTime = '' : null;
    this.course.async ? this.course.courseDate = '' : null;
  }

}
